module.exports = __webpack_public_path__ + "img/face.48ddc851.svg";